import { Runtime } from '../../Runtime';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { TickingClockwork } from './clockwork/TickingClockwork';
import { DerivedClockwork } from './clockwork/DerivedClockwork';
import { TickingClock } from './TickingClock';
import { AppClockwork } from '../../../app/modules/appClock/modules/AppClockwork';

export class RuntimeClock {
  readonly parent: Runtime;

  constructor(parent) {
    this.parent = parent;
  }

  @memoize
  get clock_minute() {
    return this.getCustomClock(60000);
  }

  @memoize
  get clock_1000() {
    return this.getCustomClock(1000);
  }

  @memoize
  get clock_250() {
    return this.getCustomClock(250);
  }

  @memoize
  get clock_100() {
    return this.getCustomClock(100);
  }

  @memoize
  get clock_frame() {
    return this.getCustomClock('frame');
  }

  customClocks = new Map<number, TickingClock>();
  getCustomClock(intervalInMs) {
    if (this.customClocks.has(intervalInMs)) {
      return this.customClocks.get(intervalInMs);
    }
    const ticking = new TickingClockwork(this, intervalInMs);
    const clock = new TickingClock(ticking);
    this.customClocks.set(intervalInMs, clock);
    return clock;
  }

  get currentDate(): Date {
    return new Date();
  }

  get currentTime(): number {
    return new Date().getTime();
  }

  get serverTime(): number {
    return this.currentTime + window.serverTime - window.clientTime;
  }

  get currentSecondsTime() {
    return Math.floor(this.currentTime / 1000);
  }

  get currentMySqlTimestamp(): string {
    return new Date().mysqlTimestamp;
  }

  get currentMySqlUTCTimestamp(): string {
    return new Date().mysqlUTCTimestamp;
  }

  dayOfYear(date): number {
    const dayCount = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
    const mn = date.getMonth();
    const dn = date.getDate();
    const dayOfYear = dayCount[mn] + dn;
    return dayOfYear;
  }

  @memoize
  get todaysDayOfYear() {
    return this.dayOfYear(new Date());
  }
}

export type AnyClockwork = TickingClockwork | DerivedClockwork | AppClockwork;
